/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import React from "react";
import About_img from "../../Images/about_img.png";
import { Link } from "react-router-dom";

const AboutHome = () => {
  return (
    <div className="p-0 m-0 box-border">
      <div className="w-[90%] mx-auto py-12 ">
        <h2 className=" font-semibold text-3xl lg:text-5xl py-8 lg:py-4">
          About PMC Limited
        </h2>
        <div className="flex flex-col-reverse md:flex-row justify-between items-start gap-6">
          <div className=" w-full lg:w-[45%] font-Inter">
            <p className="py-4 font-medium ">
              At PMC, we pride ourselves on providing effective delivery of our
              promises. Our team comprises experts with astute qualifications and experience that ensure we can guarantee our customers exceptional quality and the utmost satisfaction upon the completion of projects.
            </p>
            <p className="pt-2 font-medium">
              Our project delivery methodology puts our clients at the centre of
              all stages, from planning to delivery.
            </p>
            <Link to="/about">
            <div className="w-[300px] my-6">
              <button className="bg-background font-semibold text-white font-Urbanist p-3 rounded-lg hover:bg-navBg">
                Read More
              </button>
            </div>
            </Link>
          </div>
          <div className=" w-full lg:w-[48%]">
            <img src={About_img} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutHome;
